<template>
  <div class="inner-wrapper">
    <h1 class="members-only-title">{{ $t('ACCOUNT_MEMBER_ONLY_TITLE') }}</h1>
    <p class="members-only-supporting">{{ $t('ACCOUNT_MEMBER_ONLY_SUPPORTING') }}</p>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.inner-wrapper {
  display: flex;
  flex-direction: column;
  padding: $space-070;
  min-height: 100vh;
  width: 100%;
}

.members-only-title {
  @include font('110');
  margin-bottom: $space-060;
}

.members-only-supporting {
  @include font('070');
}
</style>
